import * as React from 'react';
import type { ApplicationChoiceDto } from '~/Features/Search/ApplicationChoice/Controller/ApplicationChoiceDto.csharp';
import { GtmCommerceEventsHandler } from '~/Partials/GoogleTagManager/GtmCommerceEventsHandler';

export function useStudyPageGtmEvents(choices?: ApplicationChoiceDto[]) {
    React.useEffect(() => {
        if (choices && choices.length !== 0) {
            GtmCommerceEventsHandler.pushProductDetail(choices);
        }
    }, [choices]);
}
